import { partfinitiClient } from 'core/services';

export const createFromQuote = async (data) =>
  (await partfinitiClient.postForm('/order/customer/create-from-quote', data)).cliJob;
